import axios from 'axios';

const REACT_APP_WALLIA_API='https://tools.wallia.cloud/contact';

export const EjectFetch = async(endpoint, param) =>  
{ 
   try {
     let response = await axios.post(REACT_APP_WALLIA_API, {
       nombre: param.name,
       correo: param.sendto,
       tema: param.title,
       mensaje: param.message || `Contacto desde el formulario - ${param.title}`
     }, {
       headers: {
         'Content-Type': 'application/json',
         'X-Auth-Token': 'wallia-secure-token-2025'
       }
     });
     
     console.log("response axios success:", JSON.stringify(response.data));
     return response.data;
   } catch (error) {
     console.log("response axios error:", error);
     throw error;
   }
}

// Keep the default export for backward compatibility
const func = {
  EjectFetch,
}
export default func;